import { requestService as api } from "../Request.service";

const API_URL = {
  API_MANAGE: `/ERP/invoice/manage.php`,
  API_SEARCH: `/ERP/invoice/search.php`,
  API_GETCODE: `/ERP/invoice/get-invcode.php`,
  API_PREFILL: `/ERP/invoice/prefill.php`,
  API_PREFILL_JO: `/ERP/invoice/prefill-jo.php`,
  API_AVAILABLE_DN: `/ERP/invoice/available-delivery.php`,
  API_AVAILABLE_CUS: `/ERP/invoice/available-customers.php`,
  API_AVAILABLE_PI: `/ERP/invoice/available-pi.php`,
  API_PREFILL_PI: `/ERP/invoice/prefill-pi.php`,
};

const InvoiceService = () => {
  const create = (parm = {}) => api.post(`${API_URL.API_MANAGE}`, parm);
  const update = (parm = {}) => api.put(`${API_URL.API_MANAGE}`, parm);
  const deleted = (code) => api.delete(`${API_URL.API_MANAGE}?code=${code}`);
  const get = (code) => api.get(`${API_URL.API_MANAGE}?code=${code}`);
  const code = () => api.get(`${API_URL.API_GETCODE}`);
  const prefill = (delcodes) => {
    const value = Array.isArray(delcodes) ? delcodes.join(",") : delcodes;
    return api.get(`${API_URL.API_PREFILL}?delcodes=${encodeURIComponent(value)}`);
  };
  const prefillJo = (jocodes) => {
    const value = Array.isArray(jocodes) ? jocodes.join(",") : jocodes;
    return api.get(`${API_URL.API_PREFILL_JO}?jocodes=${encodeURIComponent(value)}`);
  };
  /* Proforma Invoice */
  const availablePI = (keyword = "") =>
    api.get(`${API_URL.API_AVAILABLE_PI}?keyword=${encodeURIComponent(keyword)}`);
  const prefillPi = (pi_code) =>
    api.get(`${API_URL.API_PREFILL_PI}?code=${encodeURIComponent(pi_code)}`);

  const availableDeliveries = (parm = {}) => api.post(`${API_URL.API_AVAILABLE_DN}`, parm);
  const availableCustomers = (parm = {}) => api.post(`${API_URL.API_AVAILABLE_CUS}`, parm);
  const search = (parm = {}, config = {}) =>
    api.post(`${API_URL.API_SEARCH}`, parm, { ...config, cancle: true });

  return {
    create,
    update,
    deleted,
    get,
    code,
    prefill,
    prefillJo,
    availablePI,
    prefillPi,
    availableDeliveries,
    availableCustomers,
    search,
  };
};

export default InvoiceService;
